import { render, staticRenderFns } from "./ItemGroupEdit.vue?vue&type=template&id=bdf3ec72&"
import script from "./ItemGroupEdit.vue?vue&type=script&lang=js&"
export * from "./ItemGroupEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardActions,VCardTitle,VCheckbox,VCol,VContainer,VDialog,VForm,VIcon,VRow,VSelect,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1783431190/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdf3ec72')) {
      api.createRecord('bdf3ec72', component.options)
    } else {
      api.reload('bdf3ec72', component.options)
    }
    module.hot.accept("./ItemGroupEdit.vue?vue&type=template&id=bdf3ec72&", function () {
      api.rerender('bdf3ec72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/items/ItemGroupEdit.vue"
export default component.exports